export default __webpack_public_path__ + "65922e70dc7be8cee92af0bcdecdb2de.webp";